import { motion as Motion } from "framer-motion";
import cls from "./PenaltyChoiceCard.module.scss";
import mrMImg from "@/assets/UI/game/dare.webp";

export default function PenaltyChoiceCard({
  penaltyView,
  loading,
  onChooseMode,
  onConfirmCoinPaid,
}) {
  const role = penaltyView?.role || "viewer";
  const loserCoins = Number(penaltyView?.loserCoins || 0);
  const canChoose = Boolean(penaltyView?.canChooseMode);
  const canCoinPay = Boolean(penaltyView?.canConfirmCoinPayment);

  const winner = penaltyView?.winner || null;
  const loser = penaltyView?.loser || null;

  return (
    <section className={cls.stageShell}>
      <div className={cls.glowPink} />
      <div className={cls.glowBlue} />
      <div className={cls.gridLines} />

      <div className={cls.stageHeader}>
        <p className={cls.kicker}>PENALTY STAGE</p>
        <h3 className={cls.title}>Penalty Decision Time</h3>
        <p className={cls.subtitle}>
          <strong>{winner?.displayName || "Winner"}</strong> won this round. 👉{" "}
          <strong> {loser?.displayName || "Loser"}</strong> time to choose 😈
          Lose a layer… or take the dare?
        </p>
      </div>

      <div className={cls.playerStrip}>
        <article className={cls.playerMiniCard}>
          {winner?.image?.url ? (
            <img
              className={cls.playerAvatar}
              src={winner.image.url}
              alt={winner.displayName || "Winner"}
            />
          ) : (
            <div className={cls.playerAvatarFallback}>
              {(winner?.displayName || "W").slice(0, 1).toUpperCase()}
            </div>
          )}

          <div className={cls.playerInfo}>
            <p className={cls.infoLabel}>Winner</p>
            <p className={cls.playerName}>{winner?.displayName || "-"}</p>
          </div>
        </article>

        <article className={cls.playerMiniCard}>
          {loser?.image?.url ? (
            <img
              className={cls.playerAvatar}
              src={loser.image.url}
              alt={loser.displayName || "Loser"}
            />
          ) : (
            <div className={cls.playerAvatarFallback}>
              {(loser?.displayName || "L").slice(0, 1).toUpperCase()}
            </div>
          )}

          <div className={cls.playerInfo}>
            <p className={cls.infoLabel}>Loser</p>
            <p className={cls.playerName}>{loser?.displayName || "-"}</p>
          </div>

          <div className={cls.coinPill}>{loserCoins} layers</div>
        </article>
      </div>

      <div className={cls.penaltyPanel}>
        <div className={cls.backgroundWrap}>
          <div className={cls.backgroundMedia}>
            <Motion.img
              src={mrMImg}
              alt="Penalty background"
              className={cls.questionBackgroundImage}
              initial={{ scale: 1, y: 0 }}
              animate={{ scale: 1.05, y: -10 }}
              transition={{
                duration: 10,
                repeat: Infinity,
                repeatType: "reverse",
                ease: "easeInOut",
              }}
            />
          </div>

          <div className={cls.backgroundTopFade} />
          <div className={cls.backgroundBottomFade} />
          <div className={cls.backgroundGlow} />
        </div>

        <div className={cls.hudFrame}>
          <span className={cls.hudCornerTopLeft} />
          <span className={cls.hudCornerTopRight} />
          <span className={cls.hudCornerBottomLeft} />
          <span className={cls.hudCornerBottomRight} />
        </div>

        <div className={cls.questionOverlay}>
          <span className={cls.questionLabel}>PENALTY</span>

          <h4 className={cls.questionTitle}>What’s It Gonna Be?</h4>

          {role === "loser" && canChoose ? (
            <div className={cls.actionsGrid}>
              {loserCoins > 0 ? (
                <button
                  type="button"
                  className={cls.actionCard}
                  onClick={() => onChooseMode?.("coin")}
                  disabled={loading}
                >
                  <span className={cls.answerBadge}>😏</span>
                  <div className={cls.actionContent}>
                    <p className={cls.actionTitle}>Pay by a layer</p>
                    <p className={cls.actionText}>
                      {winner?.displayName || "Winner"} is blindfolded 😏 Guide{" "}
                      {winner?.displayName || "Winner"} … they get to pick which
                      layer comes off.
                    </p>
                  </div>
                </button>
              ) : null}

              <button
                type="button"
                className={cls.actionCard}
                onClick={() => onChooseMode?.("dare")}
                disabled={loading}
              >
                <span className={cls.answerBadge}>😈</span>
                <div className={cls.actionContent}>
                  <p className={cls.actionTitle}>Accept Dare</p>
                  <p className={cls.actionText}>
                    Or take the dare instead of losing a layer 😈 choose
                    carefully…
                  </p>
                </div>
              </button>
            </div>
          ) : null}

          {role === "loser" && canCoinPay ? (
            <button
              type="button"
              className={cls.primaryButton}
              onClick={() => onConfirmCoinPaid?.()}
              disabled={loading}
            >
              {loading ? "Confirming..." : "I Paid a layer"}
            </button>
          ) : null}

          {role !== "loser" ? (
            <div className={cls.waitingBox}>
              👉 Waiting on <strong>{loser?.displayName || "loser"}</strong> 😏
              Clothes… or dare?
            </div>
          ) : null}

          {role === "loser" && !canChoose && !canCoinPay ? (
            <div className={cls.waitingBox}>
              Your choice is locked in. Waiting for the next step.
            </div>
          ) : null}
        </div>
      </div>
    </section>
  );
}
